export default __webpack_public_path__ + "static/media/12.9ae69bb1.mp3";